import { render, staticRenderFns } from "./Newsdetail.vue?vue&type=template&id=55cf7194&scoped=true"
import script from "./Newsdetail.vue?vue&type=script&lang=js"
export * from "./Newsdetail.vue?vue&type=script&lang=js"
import style0 from "./Newsdetail.vue?vue&type=style&index=0&id=55cf7194&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf7194",
  null
  
)

export default component.exports